import { UserIcon, ArrowUpRight } from 'lucide-react';
import type { UserDetail } from '@/features/users/types/user.types';

interface UserProfileCardProps {
  user: UserDetail;
}

export function UserProfileCard({ user }: UserProfileCardProps) {
  return (
    <div className="flex items-start gap-3">
      <div className="flex size-12 shrink-0 items-center justify-center rounded-md bg-muted-foreground text-background">
        <UserIcon className="size-6" />
      </div>
      <div className="flex flex-col gap-0.5 min-w-0">
        <p className="text-base font-semibold truncate">{user.fullName}</p>
        {user.designationName ? (
          <p className="text-sm text-muted-foreground truncate">{user.designationName}</p>
        ) : null}
        {user.parentUserName ? (
          <p className="mt-0.5 flex min-w-0 items-center gap-1 text-xs text-muted-foreground">
            <ArrowUpRight className="size-3.5 shrink-0" />
            <span className="shrink-0">Reports to</span>
            <span className="truncate text-foreground">{user.parentUserName}</span>
          </p>
        ) : null}
      </div>
    </div>
  );
}
